import styled, { css } from 'styled-components';

export interface DevicesSelectorContainerProps {
	$notRelative?: boolean;
}

export interface DevicesSelectorProps {
	height: number;
	$notRelative?: boolean;
	$vPadding?: number;
}

export const DevicesSelectorContainer = styled.div<DevicesSelectorContainerProps>`
	${({ $notRelative = false }) => css`
		${!$notRelative && 'position: relative;'}
		display: flex;
		height: 100%;
	`}
`;

export const DevicesSelectorTrigger = styled.div`
	user-select: none;
	height: 100%;
`;

export const DevicesSelector = styled.div<DevicesSelectorProps>`
	${({ theme, height, $notRelative = false, $vPadding = 0 }) => css`
		position: absolute;
		left: 0;
		bottom: ${height + 22}px;
		z-index: 1;
		padding: 0 ${$vPadding}px;
		${$notRelative && 'width: 100%;'}

		@media ${theme.screens.screenGTS} {
			left: 4px;
			bottom: ${height + 12}px;
			padding: 0;
		}
	`}
`;

export const DevicesSelectorListContainer = styled.div`
	${({ theme }) => css`
		min-width: 214px;
		height: auto;
		background-color: #ffffff;
		border-radius: ${theme.radii.l};
		box-shadow: ${theme.shadows.base};
		padding: 24px 18px;
	`}
`;

export const DevicesSelectorListTitle = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.s};
		font-weight: ${theme.fontWeights.regular};
		color: ${theme.colors.neutral[400]};
		text-transform: uppercase;
		margin-bottom: 10px;
	`}
`;

export const DeviceContainer = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.s};
		font-weight: ${theme.fontWeights.regular};

		&:hover {
			color: ${theme.colors.brand.primary[300]};
		}
	`}
`;

export const SelectedDeviceIcon = styled.div<{ $visible: boolean }>`
	${({ $visible = false }) => css`
		${!$visible && 'visibility: hidden;'}
		display: grid;
		place-content: center;
	`}
`;

export const Separator = styled.div`
	${({ theme }) => css`
		height: 1px;
		width: 100%;
		background-color: ${theme.colors.neutral[300]};
	`};
`;
